import { Box, Button, Grid, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { UpdateApproverEmpPermissionMappingAction } from "../../../../../../store/Leave/MyAttendancePermission/Action";

const PermissionActionPopUp = ({ closeMode, editedRecord }) => {
  const initialState = {
    comment: "",
  };
  const dispatch = useDispatch();

  const [permissionData, setPermissionData] = useState(initialState);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setPermissionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (actionStatus) => {
    if (editedRecord?.employee_permission_mapping_pk) {
      dispatch(
        UpdateApproverEmpPermissionMappingAction({
          employee_permission_mapping_pk: editedRecord?.employee_permission_mapping_pk,
          status: actionStatus,
          comment: permissionData?.comment || null,
        })
      );
    }
    closeMode();
  };

  useEffect(() => {
    setPermissionData({
      ...initialState,
      ...editedRecord,
      comment: editedRecord?.comments || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedRecord]);

  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          <TextField
            fullWidth
            name="comment"
            label="Comment"
            size="small"
            multiline
            minRows={3}
            value={permissionData?.comment || ""}
            onChange={handleInput}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "space-between", m: 1.5, mt: 2 }}>
        <Button
          className="mpl-primary-btn"
          variant="outlined"
          color="primary"
          size="medium"
          onClick={closeMode}
        >
          Cancel
        </Button>
        <Box sx={{ display: "flex", gap: "1rem" }}>
          <Button
            className="mpl-primary-btn"
            variant="contained"
            size="medium"
            onClick={() => handleSubmit("Rejected")}
          >
            Reject
          </Button>
          <Button
            className="mpl-primary-btn"
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => handleSubmit("Approved")}
          >
            Approve
          </Button>
        </Box>      </Box>
    </>
  );
};

export default PermissionActionPopUp;
